import type { SvgIconProps } from '@mui/material/SvgIcon';
import { BasketballIcon, SoccerIcon, SportsIcon } from './line-icons';

/**
 * A Sport's icon, by its id (S2W-S07). No Sport column carries a back-office
 * icon — `brand_asset_keys` hold Game artwork — so the back office keeps one
 * glyph per Sport id it knows and draws the generic Sports icon for any other
 * (S2W-D06-02 allows either).
 */
const GLYPHS = {
  basketball: BasketballIcon,
  football: SoccerIcon,
} as const;

const glyphFor = (sportId: string) =>
  Object.hasOwn(GLYPHS, sportId) ? GLYPHS[sportId as keyof typeof GLYPHS] : SportsIcon;

export const SportIcon = ({ sportId, ...props }: SvgIconProps & { sportId: string }) => {
  const Glyph = glyphFor(sportId);
  return <Glyph data-glyph={Glyph === SportsIcon ? 'generic' : sportId} {...props} />;
};
